import Vue from 'vue'
let numeral = require('numeral')

Vue.filter('formatNumber', function (value) {
  return numeral(value).format('0,0')
})
